export default __webpack_public_path__ + "static/media/4247.eb94dc41.png";